var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6055 7.42188H4.39453C1.9665 7.42188 0 9.40059 0 11.8164V38.1836C0 40.6138 1.98096 42.5781 4.39453 42.5781H45.6055C48.0132 42.5781 50 40.6221 50 38.1836V11.8164C50 9.40488 48.0413 7.42188 45.6055 7.42188ZM44.99 10.3516C44.0922 11.2446 28.6409 26.6146 28.1074 27.1452C27.2773 27.9753 26.1738 28.4323 25 28.4323C23.8262 28.4323 22.7227 27.9752 21.8898 27.1425C21.5311 26.7855 6.25029 11.5854 5.00996 10.3516H44.99ZM2.92969 37.5873V12.4146L15.5896 25.0078L2.92969 37.5873ZM5.01182 39.6484L17.6668 27.0739L19.821 29.2168C21.2044 30.6002 23.0437 31.362 25 31.362C26.9563 31.362 28.7956 30.6002 30.1763 29.2195L32.3332 27.0739L44.9882 39.6484H5.01182ZM47.0703 37.5873L34.4104 25.0078L47.0703 12.4146V37.5873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailContact);
export default __webpack_public_path__ + "static/media/email-contact.ebdccb05c39659d914396fb62bcb8a65.svg";
export { ForwardRef as ReactComponent };